<nz-card class="info-card" [style]="color ? 'border-color: ' + color + ';' : 'border-color: #2496BE;'">
	<div class="content">
		<i class="icon" nz-icon nzType="bulb" nzTheme="twotone" [nzTwotoneColor]="color ? color : '#2496BE'"></i>
		<div>
			<span *ngFor="let text of texts"> {{ text }}<br> </span>
		</div>
	</div>
</nz-card>
